const quoteWizardMode = Object.freeze({
  createMode: 1,
  editMode: 2,
  quickPriceLookupMode: 3,
  amiPriceLookupMode: 4,
  orderFormMode: 5,
});
export { quoteWizardMode };
